module.exports = __webpack_public_path__ + "img/expro3.501754a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tpl/expro3.png
// module id = nAnF
// module chunks = 57